<!--directiva: avatar.component.html!-->
<div class="avatar-base" [style.width.px]="width" [style.height.px]="height">
	<div *ngIf=(!monochrome) class="avatar-img" [style.font-size.px]="fontsize" [style.background]="backgroundColor"
		[style.color]="foreColor">
		<div class="avatar-text"> {{skin}}</div>
	</div>
	<div *ngIf=(monochrome) class="avatar-img avatar-monochrome" [style.font-size.px]="fontsize">
		<div class="avatar-text"> {{skin}}</div>
	</div>
</div>